import {useEffect, useState, useRef} from "react";
import {isEqual} from "es-toolkit/compat";

const MOBILE_WIDTH = 768;
const DESKTOP_WIDTH = 1024;

const INITIAL_VALUE = {
  isMobile: window.matchMedia(`(max-width: ${MOBILE_WIDTH}px)`).matches,
  isDesktop: window.matchMedia(`(min-width: ${DESKTOP_WIDTH}px)`).matches,
  isTablet: window.matchMedia(`(min-width: ${MOBILE_WIDTH + 1}px) and (max-width: ${DESKTOP_WIDTH - 1}px)`).matches,
};

export const useMediaQuery = () => {
  const [devices, setDevices] = useState(INITIAL_VALUE);
  const previousValueRef = useRef(devices);
  const {isDesktop, isMobile, isTablet} = devices;

  useEffect(() => {
    window.addEventListener("resize", handleScreenSize);
    return () => window.removeEventListener("resize", handleScreenSize);
  }, []);

  const handleScreenSize = e => {
    const width = e?.target?.innerWidth;
    if (!width) return;

    let newDevicesValue = {};

    if (width <= MOBILE_WIDTH) {
      newDevicesValue = {
        isMobile: true,
        isDesktop: false,
        isTablet: false,
      };
    }

    if (width >= DESKTOP_WIDTH) {
      newDevicesValue = {
        isMobile: false,
        isDesktop: true,
        isTablet: false,
      };
    }

    if (width > MOBILE_WIDTH && width < DESKTOP_WIDTH) {
      newDevicesValue = {
        isMobile: false,
        isDesktop: false,
        isTablet: true,
      };
    }

    if (!isEqual(previousValueRef.current, newDevicesValue)) {
      setDevices(newDevicesValue);
      previousValueRef.current = newDevicesValue;
    }
  };

  return {isMobile, isDesktop, isTablet};
};
